'use client'

export type { HeaderProps, HeaderVariant } from './Header.types'
export { HeaderDefault as Header } from './HeaderDefault'
